import MenuCard from "./menuCard";

const MenuGrid = ({ 
    data, 
    itemType, 
    onOpenDetails, 
    showQuantity = true
}) => {
    return (
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 2xl:grid-cols-6 gap-4 p-4 bg-white border-x-2 border-b-2 rounded-b-xl shadow-sm min-h-[400px] content-start">
            {data.map((item) => (
                <MenuCard 
                    key={item.product_id || item.recipe_id || item.combo_id} 
                    item={item} 
                    itemType={itemType}
                    onClick={onOpenDetails}
                    showQuantity={showQuantity} 
                />
            ))}
        </div>
    );
};

export default MenuGrid;